import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Form, message, Input, InputNumber, notification, Table, Layout, Button, FloatButton } from 'antd';
import { SaveOutlined, EditOutlined, ClearOutlined } from '@ant-design/icons';
import { createDetalleResultado, getTiposDeResultados, gettiposperiodo, updateteDetalleResultado } from '../../services/IndicadoresService';
import './TableDetalle.css';
import { Select, Spin } from 'antd';
import { getclasificacion, getdesagregacion } from '../../services/clasificacio';
import ModalCreatePeriodo from '../clasificaciones/periodoModal';
import ModalCreateTipoResultado from '../clasificaciones/resultadoRipoModal';
import ModalCreateDesagregacion from '../clasificaciones/desagregacionModal';
import ModalCreateClasificacion from '../clasificaciones/clasifiacionModal';

const { Content } = Layout;
// Componente de Celda Editable
const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  desagregacionOptions,
  tipoResultadoSelect,
  clasificacionOptions,
  periodoSelect,
  setValorPeriocidadValue,
  setResultadoValue,
  resultadoValue,
  setNewRecord,
  children,
  setSelectedDesagregacion,
  setSelectedClasificacion,
  setSelectedPeriodo,
  setSelectedTipoResultado,
  handleClasificacionCreated,
  handledesagregacionCreated,
  handlehandleFiltrarCreated,
  handleperiodoeFiltrard,
  ...restProps
}) => {
  let inputNode;

  const handleSelectChange = (value, field) => {
    // Asegúrate de que `setNewRecord` esté definido
    setNewRecord(prevData => ({
      ...prevData,
      [field]: value,
    }));
  };

  if (dataIndex === 'clasificacion') {
    inputNode = (
      <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Select
          style={{ width: '300px' }}
          dropdownStyle={{ minWidth: '300px' }}
          showSearch
          options={clasificacionOptions.map(option => ({
            label: <span className="select-option">{option.text}</span>,
            value: option.value,
          }))}
          onChange={(value) => {
            setSelectedClasificacion(value);
            handleSelectChange(value, 'clasificacion');
          }}
          filterOption={(input, option) =>
            option?.label.props.children.toLowerCase().includes(input.toLowerCase())
          }
        />
        <ModalCreateClasificacion onClasificacionCreated={handleClasificacionCreated} />
      </div>
    );
  }
  else if (dataIndex === 'desagregacion') {
    inputNode = (
      <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Select
          style={{ width: '300px' }} // Ajusta el ancho según sea necesario
          dropdownStyle={{ minWidth: '300px' }}
          showSearch // Habilitar búsqueda
          options={desagregacionOptions.map(option => ({
            label: <span className="select-option">{option.text}</span>, // Para las opciones
            value: option.value,
          }))}
          onChange={(value) => {
            setSelectedDesagregacion(value); // Actualiza el estado
            handleSelectChange(value, 'desagregacion');
          }}
          filterOption={(input, option) =>
            option?.label.props.children.toLowerCase().includes(input.toLowerCase())
          }
        />
        <ModalCreateDesagregacion onDesagregacionCreated={handledesagregacionCreated} />
      </div>
    );
  } else if (dataIndex === 'valorPeriocidad') {
    inputNode = (
      <InputNumber onChange={(value) => setValorPeriocidadValue(value)} />
    );
  } else if (dataIndex === 'resultado') {
    inputNode = (
      <InputNumber
        value={resultadoValue}
        onChange={(value) => {
          if (value === undefined || value === null || !isNaN(value)) {
            setResultadoValue(value);
          }
        }}
        formatter={(value) => `${value}`.replace(/[^0-9.]/g, '')}
        parser={(value) => value.replace(/[^0-9.]/g, '')}
        onKeyPress={(e) => {
          if (!/[0-9.]/.test(e.key)) {
            e.preventDefault();
          }
        }}
      />
    );
  } else if (dataIndex === 'tipoResultado') {
    inputNode = (
      <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Select
          style={{ width: '300px' }} // Ajusta el ancho según sea necesario
          dropdownStyle={{ minWidth: '300px' }} showSearch // Habilitar búsqueda
          options={tipoResultadoSelect.map(option => ({
            label: <span className="select-option">{option.text}</span>, // Para las opciones
            value: option.value,
          }))}
          onChange={(value) => {
            setSelectedTipoResultado(value);
          }}
          filterOption={(input, option) =>
            option?.label.props.children.toLowerCase().includes(input.toLowerCase())
          }
        />
        <ModalCreateTipoResultado onTipoResultadoCreated={handlehandleFiltrarCreated} />
      </div>
    );
  } else if (dataIndex === 'periodo') {
    inputNode = (
      <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Select
          style={{ width: '150px' }} // Ajusta el ancho según sea necesario
          dropdownStyle={{ minWidth: '300px' }} showSearch // Habilitar búsqueda
          options={periodoSelect.map(option => ({
            label: <span className="select-option">{option.text}</span>, // Para las opciones
            value: option.value,
          }))}
          onChange={(value) => {
            setSelectedPeriodo(value); // Almacena el valor seleccionado
          }}
          filterOption={(input, option) =>
            option?.label.props.children.toLowerCase().includes(input.toLowerCase())
          }
        />
        <ModalCreatePeriodo onPeriodicidadCreated={handleperiodoeFiltrard} />
      </div>
    );
  } else {
    inputNode = <Input style={{ width: 'auto' }} />;
  }

  return (
    <td {...restProps} className="tddetalle">
      {editing ? (
        <Form.Item
          name={[record.key, dataIndex]}
          style={{ margin: 0 }}
          rules={[{ required: true, message: `Por favor, ingrese ${title}!` }]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        <span>{children}</span>
      )}
    </td>
  );
};




const TableDetalle = ({ data, onUpdate, idIndicador, onReload }) => {
  const [form] = Form.useForm();
  const [editingKeys, setEditingKeys] = useState([]);
  const [newRecord, setNewRecord] = useState({});
  const [valorPeriocidadValue, setValorPeriocidadValue] = useState([]);
  const [resultadoValue, setResultadoValue] = useState();
  const [resultadoData, setDataResultado] = useState([]);
  const [periodoData, setDataperiodo] = useState([]);
  const [isAddingRow, setIsAddingRow] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [desagregacionData, setDatadesagregacion] = useState([]);  // Initialize with an empty array
  const [clasificaciontematicaData, setDatadclasificaciontematica] = useState([]);
  const [selectedDesagregacion, setSelectedDesagregacion] = useState('');
  const [selectedClasificacion, setSelectedClasificacion] = useState('');
  const [selectedPeriodo, setSelectedPeriodo] = useState('');
  const [selectedTipoResultado, setSelectedTipoResultado] = useState('');
  const tableRef = useRef(null);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false); // Estado de carga
  // Función para eliminar filtros
  const clearFilters = () => {
    setFilters({});
    onReload()

    // Para cada columna, puedes restablecer el filtro aquí si usas un state específico
  };


  const openNotificationWithIcon = (type) => {
    api[type]({
      message: 'Actualización Exitosa',
      description: 'Los datos han sido actualizados correctamente.',
    });
  };
  const openNotificationError = (type) => {
    api[type]({
      message: 'Error al Actualizar',
      description: 'No se pudieron actualizar los datos.',
    });
  };

  const editAll = () => {
    setEditingKeys(data.map((record) => record.key));
    setIsAddingRow(false);
    const formattedValues = data.reduce((acc, record) => {
      acc[record.key] = {
        valorPeriocidad: record.valorPeriocidad,
        resultado: record.resultado,
      };
      return acc;
    }, {});
    form.setFieldsValue(formattedValues);

  };


  const cancelEdit = () => {
    setEditingKeys([]);
    form.resetFields();
    setNewRecord(null);   // Limpia el nuevo registro temporal
    setIsAddingRow(false);
  };

  const saveAll = async () => {
    if (isAddingRow) {
      await nuevoResultado();  // Step 1: Add and retrieve the new row
    } else {
      await actualizarResultado();  // Step 2: Update existing rows
    }
  };
  const actualizarResultado = async () => {
    try {
      // Validar los campos del formulario
      await form.validateFields();

      const newData = [...data];
      const editedDataArray = [];

      // Revisar las filas que están siendo editadas
      editingKeys.forEach((key) => {
        const index = newData.findIndex((item) => key === item.key);
        if (index > -1) {
          const item = newData[index];
          const updatedRow = form.getFieldValue([key]);

          // Verificar si ha habido cambios en los valores
          if (
            item.valorPeriocidad !== updatedRow.valorPeriocidad ||
            item.resultado !== updatedRow.resultado
          ) {
            editedDataArray.push({
              id: item.key,
              valor_periocidad: updatedRow.valorPeriocidad,
              valor_reultado: updatedRow.resultado,
            });

            // Actualizar los datos en newData
            newData.splice(index, 1, { ...item, ...updatedRow });
          }
        }
      });

      // Si hay datos editados, llamamos al servicio de actualización
      if (editedDataArray.length > 0) {

        const response = await updateteDetalleResultado(editedDataArray); // Enviar solo los datos editados

        if (response.status === 200) {
          onUpdate(newData); // Actualizar los datos en el estado
          setEditingKeys([]);
          openNotificationWithIcon('success');
        } else {
          openNotificationError('error');
        }
      } else {
        message.log('No hay cambios para guardar.');
      }
    } catch (errInfo) {
      message.log('Validación fallida:', errInfo);
    }
  };

  const nuevoResultado = async () => {
    const newRowData = await addNewRow(); // Make sure this is awaited to get the result
    const municipioValue = data[0]?.idmunicipio || '';

    // Prepare data to send to the API with default values if some fields are undefined
    const detalleResultadoData = {
      id_desagregacion: newRowData.desagregacion || '',
      id_clasificasion: newRowData.clasificacion || '',
      id_periodicidad: newRowData.periodo || '',
      id_tipo_resultado: newRowData.tipoResultado || '',
      municipio_id: municipioValue,
      indicador_id: idIndicador || '',
      id_tipo_resultado: newRowData.tipoResultado,
      valor_periocidad: newRowData.valor_periocidad || 0,
      valor_resultado: newRowData.valor_resultado || 0,
    };

    // newData.splice(index, 1, { ...detalleResultadoData });
    // onUpdate(newData);
    try {
      const response = await createDetalleResultado(detalleResultadoData); // Llamado a la API

      // Manejo de la respuesta
      if (response.status === 200) {
        // Éxito
        message.success('Resultado creado exitosamente');
        // onUpdate(newData); // Actualizar los datos en el estado
        onReload()

      } else if (response.status === 204) {
        // No content
        message.warning('La solicitud se procesó, pero no hubo contenido devuelto (204)');
      } else {
        // Maneja el caso de un código no esperado
        console.error(`Error en la creación del resultado: Código ${response.status}`);
      }
    } catch (error) {
      // Error en la solicitud
      console.error(`Error en la solicitud: ${error.message}`);
    }


  };



  const handleFiltrar = useCallback(async () => {
    try {
      const response = await getTiposDeResultados();

      if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
        const formattedData = response.data.map((resultado) => ({
          value: resultado.id,  // Suponiendo que `id` es el valor único de cada resultado
          text: resultado.tipo_resultado,  // `tipo_resultado` es el texto a mostrar en el Select
        }));
        setDataResultado(formattedData);  // Ahora `resultadoData` tiene objetos con `value` y `text`
      } else {
        message.error('Error al filtrar los datos.');
        setDataResultado([]);  // Si no hay datos, devolvemos un array vacío
      }
    } catch (error) {
      message.error('Error al filtrar los datos.', error);
      setDataResultado([]);  // Manejo de errores
    }
  }, []);

  const desagregacionFiltrar = useCallback(async () => {
    try {
      const response = await getdesagregacion();

      if (response.status === 200) {
        const formattedData = response.data.map((desagregacion) => ({
          value: desagregacion.id,
          text: desagregacion.descripcion,
        }));
        setDatadesagregacion(formattedData);  // Verifica que este contiene los datos esperados
      } else {
        setDatadesagregacion([]);  // Return empty array if no data
      }
    } catch (error) {
      setDatadesagregacion([]);  // Handle errors
    }
  }, []);

  const clasificaciontematicaSelect = useCallback(async () => {
    try {
      const response = await getclasificacion();
      if (response.status === 200) {
        const formattedData = response.data.map((clasificacio) => ({
          value: clasificacio.id,
          text: clasificacio.descripcion,
        }));
        setDatadclasificaciontematica(formattedData); // Esto debe actualizar el estado
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    clasificaciontematicaSelect(); // Llamada inicial para llenar las opciones
    desagregacionFiltrar();
    handleFiltrar();
    periodoeFiltrar();
  }, []);

  const handleClasificacionCreated = () => {
    clasificaciontematicaSelect(); // Refrescar las opciones al crear una nueva clasificación
  };
  const handledesagregacionCreated = () => {
    desagregacionFiltrar(); // Refrescar las opciones al crear una nueva clasificación
  };
  const handlehandleFiltrarCreated = () => {
    handleFiltrar(); // Refrescar las opciones al crear una nueva clasificación
  };

  const handleperiodoeFiltrard = () => {
    periodoeFiltrar(); // Refrescar las opciones al crear una nueva clasificación
  };

  const periodoeFiltrar = useCallback(async () => {
    try {
      const response = await gettiposperiodo();

      // Verify if the response is successful and contains data
      if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
        // Map the response data to the desired format
        const formattedData = response.data.map((periodo) => ({
          value: periodo.id,          // Use `id` as the unique value
          text: periodo.descripcion,   // Use `descripcion` for the display text
        }));

        // Update the state with the formatted data
        setDataperiodo(formattedData); // Now `dataResultado` has objects with `value` and `text`
      } else {
        // console.error('Error: No data recivida.');
        setDataperiodo([]); // If there are no data, return an empty array
      }
    } catch (error) {
      message.error('Error al filtrar los datos.', error);
      setDataperiodo([]); // Handle errors gracefully
    }
  }, []);


  const addNewRow = async () => {
    const newKey = Date.now();
    setLoading(true);
    const municipioValue = data[0]?.municipio; // Valor de municipio asegurado
    if (isAddingRow === false) {
      cancelEdit();
    }
    setIsAddingRow(true); // Activa la adición de una nueva fila

    // Llamado a las funciones de filtrado antes de añadir una nueva fila
    await desagregacionFiltrar();
    await handleFiltrar();
    await periodoeFiltrar();
    await clasificaciontematicaSelect();

    // Crear un nuevo registro usando valores disponibles o valores predeterminados
    const newRecordData = {
      key: newKey,
      desagregacion: selectedDesagregacion || '', // Usar el valor seleccionado o cadena vacía
      clasificacion: selectedClasificacion || '',
      periodo: selectedPeriodo || periodoSelect[0]?.value || '', // Usar el valor seleccionado o el primero
      municipio: municipioValue,
      tipoResultado: selectedTipoResultado || tipoResultadoSelect[0]?.value || '', // Usar el valor seleccionado o el primero
      valor_periocidad: valorPeriocidadValue || 0, // Predeterminado a 0 si no está definido
      valor_resultado: resultadoValue || 0, // Predeterminado a 0 si no está definido
    };

    // Actualizar el estado con los datos del nuevo registro
    setNewRecord(newRecordData);
    setEditingKeys((prevKeys) => [...prevKeys, newKey]);

    setLoading(false);    // console.log('Datos del nuevo registro:', newRecordData); // Log para inspección

    return newRecordData; // Asegúrate de retornar los datos del nuevo registro
  };




  // Assuming 'data' contains objects with 'desagregacion' and 'idClasificacion'
  const desagregacionOptions = [...new Set(data.map((item) => item.idDesagregacion))].map((id) => {
    const item = data.find((d) => d.idDesagregacion === id);
    return {
      text: item?.desagregacion || '', // Nombre de la desagregación
      value: item?.idDesagregacion || '', // Valor de la desagregación
    };
  });


  const clasificacionOptions = [...new Set(data.map((item) => item.clasificacion))].map((clasificacion) => {
    return {
      text: clasificacion,
      value: clasificacion, // Cambia el value para usar la clasificacion directamente
    };
  });


  const anoOptions = [...new Set(data.map((item) => item.valorPeriocidad))].map((ano) => ({
    text: ano,
    value: ano, // Assuming you want the same value as the text
  }));

  const tipoResultadoptions = [...new Set(data.map((item) => item.tipoResultado))].map((tipoResultado) => ({
    text: tipoResultado,
    value: tipoResultado,
  }));
  const tipoResultadoSelect = [...new Set(resultadoData.map((item) => item))]
    .map((item) => ({
      text: item.text,
      value: item.value,
    }));
  const periodoSelect = [...new Set(resultadoData.map((item) => item))]
    .map((item) => ({
      text: item.text,
      value: item.value,
    }));

  const desagregacionselect = [...new Set(desagregacionData.map((item) => item))].map((item) => ({
    text: item.text, // O "item.descripcion", si la estructura de datos es diferente
    value: item.value, // O "item.id"
  }));


  const clasificacionselect = [...new Set(clasificaciontematicaData.map((item) => item))].map((item) => ({
    text: item.text,
    value: item.value,
  }));

  const columns = [
    {
      title: 'Desagregación',
      dataIndex: 'desagregacion',
      width: '5%',
      editable: true,
      filters: desagregacionOptions,
      onFilter: (value, record) => record.idDesagregacion === value, // Comparación con `idDesagregacion`
      className: 'tipo-resultado-column',
    },
    {
      title: 'Clasificación Temática',
      dataIndex: 'clasificacion',
      width: '5%',
      editable: true,
      filters: clasificacionOptions,
      onFilter: (value, record) => record.clasificacion === value, // Asegura la comparación exacta
      render: (value) => value || '',
      className: 'tipo-resultado-column',
    },
    {
      title: 'Municipio',
      dataIndex: 'municipio',
      width: '5%',
      editable: false,
      render: (value) => value || '',
      className: 'tipo-resultado-column',
    },
    {
      title: 'Año',
      dataIndex: 'valorPeriocidad',
      editable: true,
      width: '5%',
      filters: anoOptions,
      onFilter: (value, record) => record.valorPeriocidad === value,
      sorter: (a, b) => a.valorPeriocidad - b.valorPeriocidad,
      render: (value) => value || '',
      className: 'tipo-resultado-column',
    },
    {
      title: 'Periodo',
      dataIndex: 'periodo',
      editable: true,
      width: '5%',
      filters: periodoSelect,
      onFilter: (value, record) => record.periodo === value,
      className: 'tipo-resultado-column',
    },
    {
      title: 'Resultado',
      dataIndex: 'resultado',
      editable: true,
      width: '5%',
      render: (value) =>
        value != null
          ? (Number.isInteger(parseFloat(value)) ? value : parseFloat(value).toFixed(2))
          : '',
      className: 'tipo-resultado-column',
    },
    {
      title: 'Tipo Resultado',
      dataIndex: 'tipoResultado',
      width: '4%',
      editable: true,
      filters: tipoResultadoptions,
      onFilter: (value, record) => record.tipoResultado === value,
      render: (value) => value || '',
      className: 'tipo-resultado-column',
    },
  ];


  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    // If adding a new row, allow editing of all fields
    if (isAddingRow) {
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: col.dataIndex === 'resultado' || col.dataIndex === 'valorPeriocidad' ? 'number' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: editingKeys.includes(record.key),
          desagregacionOptions: desagregacionData,
          clasificacionOptions: clasificacionselect,
          tipoResultadoSelect: resultadoData,
          setValorPeriocidadValue,
          setResultadoValue,
          resultadoValue,
          periodoSelect: periodoData,
          setNewRecord,
          setSelectedDesagregacion,
          setSelectedClasificacion,
          setSelectedTipoResultado,
          setSelectedPeriodo,
          clasificaciontematicaSelect,
          handleClasificacionCreated,
          handledesagregacionCreated,
          handlehandleFiltrarCreated,
          handleperiodoeFiltrard,
        }),
      };
    }

    // If editing, only allow "valorPeriocidad" and "resultado" to be editable
    if (col.dataIndex !== 'valorPeriocidad' && col.dataIndex !== 'resultado') {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'resultado' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: editingKeys.includes(record.key),
        desagregacionOptions: desagregacionData,
        clasificacionOptions: clasificacionOptions,
        tipoResultadoSelect: resultadoData,
        setValorPeriocidadValue,
        setResultadoValue,
        periodoSelect: periodoData,
        setNewRecord,
        setSelectedDesagregacion,
        setSelectedClasificacion,
        setSelectedTipoResultado,
        setSelectedPeriodo,
      }),
    };
  });
  const testLoading = async () => {
    setLoading(true);
    addNewRow()
    await new Promise(resolve => setTimeout(resolve, 5000)); // Simula una espera de 2 segundos
    setLoading(false);
  };
  
  return (
    <Layout>
      {contextHolder}
      <Content style={{ marginTop: '22px' }}>
        <Form form={form} component={false}>
          <div className='botones' > <Button
            type="primary"
            onClick={editAll}
            style={{ marginBottom: '16px' }} icon={<EditOutlined />}
          >
            Editar Todos
          </Button>
            <Button
              type="default"
              onClick={cancelEdit}
              style={{ marginBottom: '16px', marginLeft: '8px' }}
            >
              Cancelar
            </Button>
            <Button onClick={clearFilters} icon={<ClearOutlined />}
              style={{ marginBottom: '16px' }}>
              Eliminar Filtros
            </Button>
            <div className='botoncancelar'>
              <Button
                type="primary"
                onClick={testLoading}
                style={{ marginBottom: '16px', marginRight: '8px' }}
                disabled={loading}
              >
                {loading ? <Spin /> : 'Agregar'}
              </Button>
              {/* Aquí va el resto de tu componente */}
            </div>
          </div>
          <FloatButton
            type="primary"
            icon={<SaveOutlined />}
            onClick={saveAll}
            style={{
              position: 'fixed',
              bottom: '129px',
              right: '75px',    // Espaciado responsive en el borde derecho
              zIndex: 1000,     // Asegura que esté sobre otros elementos
            }}
          />
          <div>
            <Table
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              bordered
              dataSource={newRecord ? [newRecord, ...data] : data} // Inserta la nueva fila al inicio
              columns={mergedColumns}
              rowClassName="editable-row"
              locale={{ emptyText: 'No se encontraron datos' }}
              sticky
              rowKey="key"

            />


          </div>

        </Form>
      </Content>
    </Layout>
  );
};


export default TableDetalle;
